import EmberTooltip from 'ember-tooltips/components/ember-tooltip';
import EmberPopover from 'ember-tooltips/components/ember-popover';
import BvText from 'volta/components/bv-text';
import BvHr from 'volta/components/bv-hr';
import orElse from 'volta/helpers/or-else';
import or from 'ember-truth-helpers/helpers/or';
import classNames from 'volta/helpers/class-names';
import { hash } from '@ember/helper';

import type { ContentValue } from '@glint/template';
import type { TOC } from '@ember/component/template-only';
import type { TText } from 'volta/utils/text-utils';
import { type EmberTooltipBaseSignature } from 'ember-tooltips/components/ember-popover';

export type TTooltipSide = EmberTooltipBaseSignature['Args']['side'];

export interface TooltipContent {
  text?: ContentValue;
  subtext?: ContentValue;
  divider?: boolean;
}

export interface BvTooltipSignature {
  Args: EmberTooltipBaseSignature['Args'] & {
    class?: string;
    content?: (TooltipContent | undefined)[];
    subtext?: ContentValue;
    text?: TText;
    light?: boolean;
    persistOnHover?: boolean;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

const BvTooltipComponent: TOC<BvTooltipSignature> = <template>
  {{#let (if @persistOnHover (component EmberPopover) (component EmberTooltip)) as |Dropdown|}}
    <Dropdown
      @targetId={{@targetId}}
      @isShown={{@isShown}}
      @event={{orElse @event 'hover'}}
      @side={{or @side 'bottom'}}
      @effect={{orElse @effect 'none'}}
      @delay={{orElse @delay 200}}
      @spacing={{orElse @spacing 8}}
      @popperContainer={{orElse @popperContainer 'body'}}
      @arrowClass={{classNames 'bv-tooltip__arrow' @arrowClass}}
      @innerClass={{classNames 'bv-tooltip__inner' @innerClass}}
      @tooltipClass={{classNames 'bv-tooltip' (if @light 'bv-tooltip--light') @class}}
      @popperOptions={{orElse
        @popperOptions
        (hash modifiers=(hash preventOverflow=(hash escapeWithReference=false)))
      }}
      ...attributes
    >
      {{#if (has-block)}}
        {{yield}}
      {{else}}
        {{@text}}
      {{/if}}
      {{#if @subtext}}
        <BvText class='u-d-flex u-color-gray-3'>
          {{@subtext}}
        </BvText>
      {{/if}}
      {{#each @content as |item|}}
        {{#if item}}
          {{#if item.divider}}
            <BvHr class={{classNames 'u-my-2' (unless @light 'u-bg-gray-7')}} />
          {{/if}}
          {{#if item.text}}
            {{item.text}}
          {{/if}}
          {{#if item.subtext}}
            <BvText class='u-d-flex u-color-gray-3'>
              {{item.subtext}}
            </BvText>
          {{/if}}
        {{/if}}
      {{/each}}
    </Dropdown>
  {{/let}}
</template>;

export default BvTooltipComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvTooltip: typeof BvTooltipComponent;
    'bv-tooltip': typeof BvTooltipComponent;
  }
}
